import React from 'react';

interface RequiredLabelProps {
  label: string;
  required?: boolean;
  htmlFor?: string;
  id?: string;
  className?: string;
}

/** Reusable label with red required asterisk (*) for Create/Edit User dialogs */
const RequiredLabel: React.FC<RequiredLabelProps> = ({
  label,
  required = false,
  htmlFor,
  id,
  className = '',
}) => (
  <label
    id={id}
    htmlFor={htmlFor}
    className={`create-user-dialog-label ${className}`.trim()}
  >
    {label}
    {required && (
      <span
        className="create-user-dialog-required-star"
        aria-hidden
      >
        *
      </span>
    )}
  </label>
);

export default RequiredLabel;
